// 外链到用户后台全局变量配置
// const url = 'https://127.0.0.1:8000' // 本地环境
// const url = 'http://47.111.9.48:8089' //
// const url = 'http://47.111.173.190:6586' // 新测试环境
export const appUrl = 'https://user.chaojidun.com' // 正式环境 超级盾（App）用户后台 旧版
// export const appUrl = 'https://user.upk.net' // 正式环境 超级盾（App）用户后台 新版
export const pcUrl = 'https://user.pcp.chaojidun.com' // 正式环境 PC盾 用户后台
export const pcOfficialUrl = 'https://pcp.chaojidun.com' // 正式环境 PC盾 官网
export const superCloudUrl = 'https://yun.chaojidun.com' //正式环境 超级云 官网（用户已确认）
export const downloadUrl = 'https://download.upk.net' //正式环境 新版
//export const downloadUrl = 'https://download.chaojidun.com' //正式环境 旧版




// WEBPACK FOOTER //
// ./src/assets/js/url.js